import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

import { SharedService } from 'baseline-lib';
import { Event } from 'baseline-lib';
import { Market } from 'baseline-lib';
import { Selection } from 'baseline-lib';
import { EventListing } from 'baseline-lib';
import { EventListingService } from 'baseline-lib';
import { VirtualListingService } from 'baseline-lib';

@Component({
  selector: 'app-leagues-listing',
  templateUrl: 'leagues-listing.html'
})
export class LeaguestListingComponent implements OnInit {

  @Input() eventId: number;

  EventListObj: EventListing;
  current: number = 0;
  subMarketGid: number = 0;
  selectedMgli: Market;
  //  showanyorder:boolean;
  constructor(
    private _virtualListingService: VirtualListingService,
    private _eventListingService: EventListingService,
    private _sharedService: SharedService
  ) {
    this.EventListObj = new EventListing();
  }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.eventId) {
      this.eventId = changes.eventId.currentValue as number;
      this.EventListObj = this._eventListingService.EventListObj;            
      this.subMarketGid = 0;

      this.eventGroupChange(this.EventListObj.selectedEvent.egli[0]);
    }
  }


  eventMarketGroupChange()
  {
    this._sharedService.showLoader();
    this.subMarketGid =0;
    if(this.EventListObj.selectedEvent.mli && this.EventListObj.selectedEvent.mli.length > 0) {
      this.EventListObj.selectedEvent.mli.forEach(element => {
          element.isSelected = false;
      })
    }
    this.EventListObj.selectedEvent.mgli.forEach(element => {
     element.isSelected = false;
    })
    //_marketG.isSelected = true;
    this.EventListObj.selectedMarket.isSelected = true ;
    this._sharedService.hideLoader();
  }

  eventSubMarketGroupChange(_marketG: Market, w: any) {
    this._sharedService.showLoader();
    this.subMarketGid =_marketG.gid;
    this._sharedService.hideLoader();
  }

  // on click of odds selection
  BetSelection(_selection: Selection, market: Market, event: any) {
    var _e = new Event();
    _e.odt = event.cdt;
    _e.cdt = event.eet;
    _e.eno = event.eno;
    _e.eventid = event.id;
    _e.en = event.en;
    _e.gid = event.gid;
    _e.count = 0;
    this._virtualListingService.BetSelection(_selection, market, _e, this.EventListObj.gameObj);
  }


  /* Draw List Carousel Init method */
  public initDrawlistCarousel(event) {
    event.relatedTarget.options.margin = 20;
    event.relatedTarget.options.responsiveClass = true;
    event.relatedTarget.options.responsive = {
      0: {
        items: 2,
        nav: true
      },
      768: {
        items: 5,
        nav: false
      },
      1100: {
        items: 6,
        nav: true,
        loop: false,
        margin: 5
      }
    }
  }

  eventGroupChange(eventGroup) {
    //this.EventListObj.selectedEvent.egli.forEach(evt=> evt.isSelected = false);
    this.selectedMgli = eventGroup.mgli;
    this.selectedMgli[0].isSelected = true;
    this.EventListObj.selectedMarket = this.selectedMgli[0];
    //this.selectedMarket = this.selectedMgli[0];
    //eventGroup.isSelected = true;
    //eventGroup.egli = this.EventListObj.selectedEvent.egli;
    //this.EventListObj.selectedEvent = eventGroup;
    //this._eventListingService.marketlisting(2, 0);
  }
}



// WEBPACK FOOTER //
// ./src/app/virtual-sports/leagues-listing/leagues-listing.ts